import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width"];
import React from 'react';
import { Grid } from 'semantic-ui-react';
import Image from '../../atoms/Image';
export default function ContentImage(_ref) {
  var width = _ref.width,
    imageProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Grid.Column, {
    className: "content-section-image",
    width: width
  }, /*#__PURE__*/React.createElement(Image, imageProps));
}
ContentImage.defaultProps = {
  width: undefined
};